import { useEffect, useState } from 'react';
import { useTracking } from '@podiumhq/tracking';

import useInitIpqs from 'components/ThirdPartyScripts/hooks/useInitIpqs';
import useEventListener from 'hooks/useEventListener';
import { checkIfIsInMarketingIframe, PODIUM_HOSTNAME } from 'lib/iframeUtils';
import { useTrialContextData } from 'contexts/TrialsContextProvider';

const useIsInView = () => {
  const [isInPodiumIframe, setIsInPodiumIframe] = useState(false);
  const [isInView, setIsInView] = useState(false);

  const { trialPageVariantSlug } = useTrialContextData();
  const { trackEvent } = useTracking();

  useInitIpqs(isInView);

  const handlePageIsInView = (event) => {
    const isStartTrialClicked = event?.data === 'start trial clicked';

    if (isStartTrialClicked && event?.origin?.includes(PODIUM_HOSTNAME)) {
      setIsInView(true);
    }
  };

  useEffect(() => {
    const isPodiumIframe = checkIfIsInMarketingIframe();
    setIsInPodiumIframe(isPodiumIframe);

    if (!isPodiumIframe) {
      setIsInView(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEventListener({
    eventName: 'message',
    handler: isInPodiumIframe ? handlePageIsInView : null,
  });

  useEffect(() => {
    if (isInView) {
      trackEvent('trials.accountInfo.visited', {
        landingPageVariant: trialPageVariantSlug,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInView]);

  return { isInPodiumIframe, isInView };
};

export default useIsInView;
